(() => {
  if (window.__bitcoWishlistBound) return;
  window.__bitcoWishlistBound = true;

  const KEY = 'bitco:wishlist';

  // In-memory source of truth for the session. localStorage is only a
  // best-effort persistence layer: when setItem fails silently (private
  // browsing, quota), toggling must still work within the session, so no
  // sync/render path ever reads storage directly.
  let handles = [];

  // Returns an array on a successful storage read (getItem returning null
  // means "nothing stored" — a valid empty wishlist), or null when storage
  // itself is unavailable (getItem threw).
  const readStorage = () => {
    let raw = null;
    try {
      raw = localStorage.getItem(KEY);
    } catch (e) {
      return null;
    }
    if (raw === null) return [];
    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed.filter((h) => typeof h === 'string') : [];
    } catch (e) {
      return [];
    }
  };

  const persist = () => {
    try { localStorage.setItem(KEY, JSON.stringify(handles)); } catch (e) {}
  };

  const sync = () => {
    document.querySelectorAll('[data-bitco-wishlist-toggle]').forEach((btn) => {
      const active = handles.indexOf(btn.dataset.handle) !== -1;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', String(active));
    });
    document.querySelectorAll('[data-bitco-wishlist-count]').forEach((el) => {
      el.textContent = String(handles.length);
      el.classList.toggle('is-empty', handles.length === 0);
    });
  };

  const toggle = (handle) => {
    const index = handles.indexOf(handle);
    if (index === -1) {
      handles.push(handle);
    } else {
      handles.splice(index, 1);
    }
    persist();
    sync();
    document.dispatchEvent(new CustomEvent('bitco:wishlist-change', { detail: { handles: handles.slice() } }));
  };

  const init = () => {
    const stored = readStorage();
    if (stored !== null) handles = stored;
    sync();
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-bitco-wishlist-toggle]');
      if (!btn) return;
      e.preventDefault();
      toggle(btn.dataset.handle);
    });
    document.addEventListener('shopify:section:load', () => {
      const stored = readStorage();
      if (stored !== null && JSON.stringify(stored) !== JSON.stringify(handles)) handles = stored;
      sync();
    });
  };

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
